import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ScrollToTop from '../components/Global/ScrollToTop';
import BackToTop from '../components/Global/BackToTop';
import TimedModal from '../components/Global/TimedModal';
import Contact from '../components/Main/Contact';

const MainLayout = () => {
	const location = useLocation();
	const noFooter = ['/login', '/signup'];
	const blackNav = [
		'/login',
		'/signup',
		'/admin',
		'/privacy',
		'/terms',
		'/services',
		'/about',
	];
	return (
		<div className=''>
			<Navbar blackAlways={blackNav.includes(location.pathname)} />
			{/* <TimedModal
				children={
					<div className='h-full flex flex-col justify-center items-center align-middle'>
						<Contact modal={true} />
					</div>
				}
			/> */}
			<Outlet />
			{noFooter.includes(location.pathname) ? null : <Footer />}

			<ScrollToTop />
			<BackToTop />
		</div>
	);
};

export default MainLayout;
